import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import arrow from '../../../../assets/images/reg-guide/arrow.svg';
import subtitle from '../../../../assets/images/reg-guide/child-subtitle-bg.png';

const emphasisColor = '#685bc7';

export const useStyles = makeStyles(({
  fontWeights, fontSizes, palette, breakpoints, siteMaxWidth,
}: Theme) => ({
  root: {
    paddingLeft: 16,
    paddingRight: 16,
    [breakpoints.up('md')]: {
      width: '100%',
      maxWidth: siteMaxWidth,
      margin: '0 auto',
    },
  },
  title: {
    marginTop: '2rem',
    marginBottom: 16,
    color: palette.info.dark,
    fontSize: fontSizes.lg,
    lineHeight: 1.35,
    fontWeight: fontWeights.medium,
    textAlign: 'center',
    scrollMarginTop: '6rem',
    [breakpoints.up('md')]: {
      marginBottom: 34,
      fontSize: 22,
    },
  },
  emphasis: {
    color: palette.secondary.main,
    fontSize: 26,
    [breakpoints.up('md')]: {
      fontSize: 30,
    },
    [breakpoints.up('lg')]: {
      fontSize: 46,
    },
  },
  newLine: {
    display: 'block',
  },
  stepsWrapper: {
    position: 'relative',
    paddingTop: 36,
    [breakpoints.up('lg')]: {
      paddingTop: 52,
    },
  },
  stepsWrapperChild: {
    padding: '0 0.625rem',
  },
  arrow: {
    position: 'absolute',
    top: '52%',
    left: '65%',
    width: 90,
    height: 30,
    transform: 'translate(-50%, -50%) rotate(90deg)',
    display: 'block',
    backgroundImage: `url(${arrow})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    zIndex: 2,
    [breakpoints.up('md')]: {
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    [breakpoints.up('lg')]: {
      width: 180,
      height: 50,
    },
  },
  subtitle: {
    width: '100%',
    maxWidth: '48rem',
    height: 445,
    margin: '0 auto 2.25rem',
    padding: '1.25rem 0 0 0.675rem',
    background: `#cbe880 no-repeat url(${subtitle}) bottom right`,
    backgroundSize: '90% auto',
    color: palette.info.dark,
    fontSize: fontSizes.lg,
    lineHeight: 1.5,
    fontWeight: fontWeights.medium,
    textAlign: 'center',
    scrollMarginTop: '5rem',
  },
  emphasisChild: {
    display: 'block',
    color: emphasisColor,
    fontSize: '1.375rem',
  },
}));
